import React, { Component } from "react";

// components
import Phone from "./Phone/Phone";
import Upload from "./Upload/Upload";
import Radiogroup from "./Radiogroup/Radiogroup";
import Autocomplete from "./Autocomplete/Autocomplete";
import Textarea from "./Textarea/Textarea";
import Text from "./Text/Text";
import Checkbox from "./Checkbox/Checkbox";

export default class Field extends Component {
  render() {
    const {
      title,
      name,
      type,
      placeholder,
      change,
      value,
      validate,
      index,
      url,
      error,
      options,
      desc,
      info,
    } = this.props;

    let Field = null;
    if (type === "text") {
      Field = (
        <Text
          {...{
            name,
            index,
            title,
            validate,
            value,
            change,
            type,
            placeholder,
          }}
        />
      );
    } else if (type === "textarea") {
      Field = (
        <Textarea
          {...{
            name,
            index,
            value,
            title,
            validate,
            change,
            type,
            placeholder,
          }}
        />
      );
    } else if (type === "autocomplete") {
      Field = (
        <Autocomplete
          {...{ name, index, placeholder, title, validate, change, value, url }}
        />
      );
    } else if (type === "radioGroup") {
      Field = <Radiogroup {...{ name, index, options, change, value }} />;
    } else if (type === "upload") {
      Field = <Upload {...{ name, index, value, change }} />;
    } else if (type === "phone") {
      Field = (
        <Phone
          {...{ name, index, title, value, placeholder, validate, change }}
        />
      );
    } else if (type === "checkbox") {
      Field = <Checkbox {...{ name, index, type, title, value, change }} />;
    }

    return (
      <div
        id={name}
        className={`form-field mb-8 relative field-${type} w-full ${
          error ? "has-error" : ""
        }${info ? " md:pr-0 pr-16" : ""}`}
      >
        {Field}
        {desc ? (
          <div className="tip text-grey-dark text-sm my-3 max-w-sm2">
            {desc}
          </div>
        ) : null}
        {error ? (
          <div
            className="error text-red text-sm my-3 max-w-sm2"
            dangerouslySetInnerHTML={{ __html: error }}
          />
        ) : null}
        {info ? (
          <button
            aria-label={`Info ${title}`}
            type="button"
            className="num info-button absolute pin-r md:-mr-6 cursor-pointer ml-6 w-12 h-12 rounded-full border-2 border-grey-lighter text-red flex items-center justify-center md:bg-transparent bg-white"
            onClick={() => this.props.overlayHandler(info)}
          >
            ?
          </button>
        ) : null}
      </div>
    );
  }
}
